import { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AuthLayout from "./layouts/AuthLayout";
import OnboardingLayout from "./layouts/OnboardingLayout";
import DashboardLayout from "./layouts/DashboardLayout";
import LayoutWithNavbar from "./layouts/LayoutWithNavbar";
import LoginPage from "./pages/LoginPage";
import ClientOnboardingEntry from "./pages/ClientOnboardingEntry";
import DashboardHome from "./pages/DashboardHome";
import AppEntry from "./pages/AppEntry";
import { AuthContext } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

export default function App() {
  const { isAuthenticated, onboardingCompleted } = useContext(AuthContext);

  return (
    <Routes>
      {/* Public / Auth routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* Protected app entry that decides onboarding vs dashboard */}
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppEntry />
          </ProtectedRoute>
        }
      />

      <Route element={
        <ProtectedRoute>
          <LayoutWithNavbar />
        </ProtectedRoute>
      }>

        {/* Onboarding routes (protected) */}
        <Route element={
          <ProtectedRoute>
            <OnboardingLayout />
          </ProtectedRoute>
        }
        >
          <Route path="/onboarding" element={<ClientOnboardingEntry />} />
        </Route>

        {/* Dashboard routes (protected) */}
        <Route
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={onboardingCompleted ? (<DashboardHome />) : (<Navigate to="/onboarding" replace />)}/>
        </Route>
      </Route>
      {/* Root route */}
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <Navigate to="/app" replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
